import { render } from "./AccompanistDashboard.vue?vue&type=template&id=62509839&scoped=true"
import script from "./AccompanistDashboard.vue?vue&type=script&lang=js"
export * from "./AccompanistDashboard.vue?vue&type=script&lang=js"

import "./AccompanistDashboard.vue?vue&type=style&index=0&id=62509839&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62509839"]])

export default __exports__